export function formatUnicodeNormalizationCheck(check) {
  return `string must be unicode-normalized with ${check.normalization}`;
}
